import { SuperButton } from '@devinforius/super-compos-17';
import { TranslateService } from '@devinforius/super-compos-17';
import { InfosComponent } from './infos.component';
import moment from 'moment';

export function getButtonsTitle(component: InfosComponent, translate: TranslateService): SuperButton[] {
  const buttons: SuperButton[] = [
    {
      text: translate.translate('btn.cancel'),
      styleClass: 'red',
      id: 'idUpdateThisPoint',
      icon: 'fas fa-ban',
      iconPosition: 'left',
      click: () => {
        if (component.statut === 'update') {
          component.realeseWriteLock();
        } else {
          component.goBack();
        }
      },
    },
  ];
  if (component.statut === 'create') {
    buttons.push({
      text: translate.translate('btn.saveAndNextStep'),
      styleClass: 'green',
      id: 'idCreateThisPoint',
      icon: 'fas fa-arrow-circle-right',
      iconPosition: 'left',
      disabled: !component.infosFormComponent?.infosForm?.valid,
      click: () => {
        component.validateAndSave();
      },
    });
    buttons.splice(0, 0, {
      text: translate.translate('btn.useModelPoint'),
      styleClass: 'blue',
      id: 'idUsePointModel',
      disabled: true,
      click: () => {
        component.getModelesPoints();
      },
    });
  }
  if (component.statut === 'update') {
    buttons.push({
      text: translate.translate('btn.saveAndLeave'),
      styleClass: 'green',
      id: 'idUpdateThisPoint',
      icon: 'fas fa-arrow-circle-right ml-2',
      iconPosition: 'left',
      click: () => {
        component.updatePoint();
      },
    });
  }
  if (component.statut === 'duplicate') {
    buttons.push({
      text: translate.translate('btn.saveAndLeave'),
      styleClass: 'green',
      id: 'idUpdateThisPoint',
      icon: 'fas fa-arrow-circle-right ml-2',
      iconPosition: 'left',
      click: () => {
        component.validateAndSave(true, 'duplicate');
      },
    });
  }
  if (component.statut === 'createFromIcourrier') {
    buttons.push(
      {
        text: translate.translate('btn.saveAndLeave'),
        styleClass: 'blue',
        id: 'idCreateThisPoint',
        icon: 'fas fa-arrow-circle-right',
        iconPosition: 'left',
        // disabled: !component.infosForm.valid,
        click: () => {
          component.validateAndSave(true);
        },
      },
      {
        text: translate.translate('btn.saveAndNextStep'),
        styleClass: 'green',
        id: 'idCreateThisPoint',
        icon: 'fas fa-arrow-circle-right',
        iconPosition: 'left',
        // disabled: !component.infosForm.valid,
        click: () => {
          component.validateAndSave();
        },
      }
    );
  }
  return buttons;
}

export function getColumnsModelesPoints() {
  const columnsModelesPoints = [
    {
      field: 'serviceLabel',
      header: 'Service',
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
    {
      field: 'typeSeanceLabel',
      header: 'Type de séance',
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
    {
      field: 'objet',
      header: 'Titre',
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
    {
      field: 'createdBy',
      header: 'Créé par',
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
    {
      field: 'createdOnLabel',
      header: 'Date de création',
      format: (_, item) => {
        if (item.createdOn) {
          return moment(item.createdOn).format('DD/MM/YYYY');
        }
      },
    },
    {
      field: 'modifiedBy',
      header: 'Modifié par',
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
    {
      field: 'modifiedOnLabel',
      header: 'Date de modification',
      format: (_, item) => {
        if (item.modifiedOn) {
          return moment(item.modifiedOn).format('DD/MM/YYYY');
        }
      },
    },
    {
      field: 'matiereLabel',
      header: 'Matière',
      visible: false,
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
    {
      field: 'defautObjetTypeLabel',
      header: 'Type de point',
      visible: false,
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
    {
      field: 'description',
      header: 'Description',
      visible: false,
      format: (v) => {
        if (v) {
          return v;
        }
      },
    },
  ];
  return columnsModelesPoints;
}
